import BaseRequest from './base/BaseRequest';

export default class SettingRequest extends BaseRequest {

    getShowRemainAML() {
      const url = '/get-show-remain-aml';
      return this.get(url);
    }

    getPairCoinSettings(params) {
      const url = '/prices/pair-coin-settings';
      return new Promise((resolve, reject) => {
        this.get(url, params).then((e) => resolve({ data: e })).catch(reject)
      });
    }
  }
  